import { CommonModule, NgFor, NgIf } from '@angular/common'
import { Component, OnInit, ViewChild } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { Router } from '@angular/router'
import { NgIcon, provideIcons } from '@ng-icons/core'
import { heroDocument, heroPencil } from '@ng-icons/heroicons/outline'
import { KENDO_BUTTON, KENDO_BUTTONS } from '@progress/kendo-angular-buttons'
import { KENDO_DIALOGS } from '@progress/kendo-angular-dialog'
import { DropDownListComponent, GroupTagTemplateDirective, HeaderTemplateDirective, KENDO_DROPDOWNLIST, KENDO_DROPDOWNS, KENDO_MULTISELECT, SummaryTagDirective } from '@progress/kendo-angular-dropdowns'
import { CellTemplateDirective, ColumnComponent, ExcelCommandDirective, ExcelComponent, GridComponent, GridToolbarFocusableDirective, KENDO_GRID, KENDO_GRID_EXCEL_EXPORT, KENDO_GRID_PDF_EXPORT, ToolbarTemplateDirective } from '@progress/kendo-angular-grid'
import { KENDO_INDICATORS } from '@progress/kendo-angular-indicators'
import { CheckBoxDirective, KENDO_INPUTS } from '@progress/kendo-angular-inputs'
import { State } from '@progress/kendo-data-query'
import { ToastrService } from 'ngx-toastr'
import { repOsjupdate } from '../../../@core/interfaces/common/users'
import { ClientServices } from '../../../@theme/services/clients.service'
import { InitUserService } from '../../../@theme/services/init-user.service'
import { TypesServices } from '../../../@theme/services/typeslist.service'
import { RepEditorStateService } from '../shared/rep-editor-state.service'
import { RepReportsComponent } from './rep-reports/rep-reports.component'
import { PhonePipe } from '../../../@theme/pipes/phone.pipe'


@Component({
  selector: 'gd-view-reps',
  templateUrl: './view-reps.component.html',
  styleUrls: ['./view-reps.component.scss'],
  imports: [
    CommonModule,
    KENDO_DROPDOWNS,
    KENDO_GRID,
    KENDO_INPUTS,
    KENDO_GRID_PDF_EXPORT,
    KENDO_GRID_EXCEL_EXPORT,
    KENDO_INDICATORS,
    KENDO_DIALOGS, KENDO_BUTTONS,
    KENDO_DROPDOWNLIST,
    KENDO_BUTTON,
    DropDownListComponent,
    FormsModule,
    NgIf,
    CheckBoxDirective,
    KENDO_DROPDOWNS,
    KENDO_GRID,
    KENDO_INPUTS,
    KENDO_GRID_PDF_EXPORT,
    KENDO_GRID_EXCEL_EXPORT,
    KENDO_INDICATORS,
    KENDO_DIALOGS,
    KENDO_BUTTONS,
    KENDO_MULTISELECT,
    SummaryTagDirective,
    HeaderTemplateDirective,
    GroupTagTemplateDirective,
    RepReportsComponent,
    NgFor,
    GridComponent,
    ToolbarTemplateDirective,
    ExcelCommandDirective,
    GridToolbarFocusableDirective,
    ColumnComponent,
    CellTemplateDirective,
    NgIcon,
/*     RouterLinkActive, */
    ExcelComponent,
    /*    DatePipe, */
    PhonePipe,
  ],
  providers: [
    provideIcons({ heroDocument, heroPencil })
  ]
})
export class ViewRepsComponent implements OnInit {
  groupedReps: { [key: string]: any[] } = {};
  public letters: string[] = [];
  public currentLetter: string = '';
  public displayedReps: any[] = [];
  public showAllReps: boolean = true; // Default to showing all reps
  public pageSize = 10;
  public skip = 0;

  @ViewChild(GridComponent, { static: true })
  public grid: GridComponent
  public repList: any[]
  public activeRepList: any[]
  public sortedRepList: any[]
  public allRepReports: any[]
  public excelRepReports: any[]
  public pdfRepReports: any[]
  public hidebyRole: boolean
  public reports = false
  public selectedRepReportId: string
  private roleing: string
  private roleing2: string
  public hideOsJ: boolean
  // Excel Report State
  public excelShowActive: boolean
  public excelFirmSelection: any
  public excelReportSelection: any
  public excelReportParams = {}
  public showExcelActiveCheckbox = false
  public showExcelFirmDropdown = false

  // PDF Report State
  public pdfShowActive: boolean
  public pdfRepSelection: any
  public pdfRepSelectionList: any[]
  public pdfReportSelection: any
  public showPdfActiveCheckbox = false
  public showPdfRepDropdown = false
  public showPdfRepMultiselect = false

  public state: State = {
    filter: {
      logic: 'and',
      filters: [],
    },
  }

  constructor(
    private getstring: InitUserService,
    private router: Router,
    private clientServices: ClientServices,
    private repState: RepEditorStateService,
    private typesService: TypesServices,
    private toastrService: ToastrService,
  ) {
    this.hidebyRole = false
    this.hideOsJ = true
  }

  ngOnInit() {
    this.loadRepList()
    this.loadRepReports()
    this.loadReportFilterData()
  }
  groupByLetter(data: any[]): { [key: string]: any[] } {
    return data.reduce((acc, item) => {
      const letter = item.lastName?.charAt(0).toUpperCase() || '#';
      if (!acc[letter]) {
        acc[letter] = [];
      }
      acc[letter].push(item);
      return acc;
    }, {});
  }
  public loadRepList(): void {
    this.clientServices.getRepViewList().subscribe((response) => {
      this.repList = response;

      this.activeRepList = this.repList
        .filter((rl) => rl.lastName)
        .sort((a, b) => a.lastName?.localeCompare(b.lastName))

      this.sortedRepList = this.activeRepList;

      // Group by letter
      this.groupedReps = this.groupByLetter(this.sortedRepList);

      // Extract available letters
      this.letters = Object.keys(this.groupedReps).sort();

      // Default logic: show all if enabled, else first letter
      if (this.showAllReps) {
        this.displayedReps = this.sortedRepList;
        this.currentLetter = '';
      } else if (this.letters.length > 0) {
        this.setCurrentLetter(this.letters[0]);
      } else {
        this.displayedReps = []; // nothing to show
      }

      // Remaining role logic...
      this.getstring.currentRole.subscribe((r) => {
        const getrolesplit = r.split('|');
        this.roleing = getrolesplit[0];
        this.roleing2 = getrolesplit[1];
      });

      this.hidebyRole = this.roleing2 === 'REP';

      if (
        this.roleing2 === 'TRADING USER' ||
        this.roleing2 === 'TRADING PRINCIPAL' ||
        this.roleing2 === 'INSURANCE USER' ||
        this.roleing2 === 'INSURANCE PRINCIPAL' ||
        this.roleing2 === 'ADMIN'
      ) {
        this.hideOsJ = false;
      }
    });
  }


  public loadRepReports(): void {
    this.clientServices.getRepReports().subscribe((response) => {
      this.allRepReports = response
      this.excelRepReports = this.allRepReports.filter(
        (r) => r.type === 'Export',
      )
      this.pdfRepReports = this.allRepReports.filter((r) => r.type === 'Print')
    })
  }
  public setCurrentLetter(letter: string): void {
    this.showAllReps = false; // Switch back to letter filtering
    this.currentLetter = letter;
    this.displayedReps = this.groupedReps[letter] || [];
  }

  public toggleShowAll(): void {
    this.showAllReps = !this.showAllReps;
    if (this.showAllReps) {
      this.currentLetter = ''; // Clear current letter selection
      this.displayedReps = this.sortedRepList; // Show all reps
    } else {
      // Go back to first letter
      if (this.letters.length > 0) {
        this.setCurrentLetter(this.letters[0]);
      }
    }
  }
  public loadReportFilterData() {
    if (!this.repState.firmTypeList) {
      this.typesService.getFirmTypes().subscribe((response) => {
        this.repState.firmTypeList = response
      })
    }
  }
  public editRep(repId: number): void {
    this.router.navigate(['/pages/rep-editor/edit'], {
      queryParams: { repId: repId },
    })
  }
  public changeOSJflag(dataItem: repOsjupdate, field: string): void {
    dataItem[field] = !dataItem[field]
    const first = dataItem['firstName'].toString()
    const last = dataItem['lastName'].toString()
    setTimeout(() => {
      this.showtoaster(first, last)
    }, 1000)
    this.typesService.OSJUpdateRep(dataItem).subscribe()
  }
  public showtoaster(first: string, last: string): void {
    this.showToast(
      'success',
      `You have successfully updated rep ${first} ${last}`,
    )
  }
  public goToReports(): void {
    this.reports = true
  }

  public loadExcelReport() {
    this.selectedRepReportId = this.excelReportSelection.repReportId
    this.excelReportParams = {}
    if (this.showExcelActiveCheckbox) {
      this.excelReportParams['@Active'] = '' + this.excelShowActive
    }
    if (this.showExcelFirmDropdown) {
      this.excelReportParams['@FirmType'] =
        '' + this.excelFirmSelection.firmTypeID
    }
    const reportName = this.excelReportSelection.reportName
    this.clientServices
      .getReportData({
        repReportId: this.selectedRepReportId,
        genericParams: this.excelReportParams,
      })
      .subscribe((response) => {
        const url = window.URL.createObjectURL(response)
        const link = document.createElement('a')
        link.href = url
        link.download = reportName.replaceAll(' ', '') + '.csv'
        link.click()
        URL.revokeObjectURL(url)
      })
  }

  public loadPdfReport() {
    const singlePdfReportParams = {}
    const multiPdfReportParams = {}
    if (this.showPdfActiveCheckbox) {
      singlePdfReportParams['Active'] = '' + this.pdfShowActive
    }
    if (this.showPdfRepDropdown) {
      if (!this.pdfRepSelection) {
        this.showToast('warning', 'Please select a rep.')
        return
      }
      singlePdfReportParams['RepID'] = '' + this.pdfRepSelection.repId
    }
    if (this.showPdfRepMultiselect) {
      multiPdfReportParams['ShortNames'] = this.pdfRepSelectionList.map(
        (rsl) => rsl.shortName,
      )
    }
    const reportName = this.pdfReportSelection.reportName
    this.clientServices
      .getReportPdf({
        repReportId: this.pdfReportSelection.repReportId,
        genericParams: singlePdfReportParams,
        genericParamSets: multiPdfReportParams,
      })
      .subscribe({
        next: (response) => {
          const url = window.URL.createObjectURL(response)
          const link = document.createElement('a')
          link.href = url
          link.download = reportName + '.pdf'
          link.click()
          URL.revokeObjectURL(url)
        },
        // handleError rethrows the HttpErrorResponse as an 'Error Code: <status>' string
        error: (err) => {
          if (String(err).includes('Error Code: 400')) {
            this.showToast('warning', 'No data to print.')
          } else {
            this.showToast('error', 'Unable to generate the PDF report.')
          }
        },
      })
  }
  onAddRepClick() {
    this.router.navigate(['/pages/rep-editor/edit']);
  }
  public excelReportValueChange() {
    this.showExcelActiveCheckbox = this.excelReportSelection.filters.some(
      (f) => f.filter === 'Active',
    )
    this.showExcelFirmDropdown = this.excelReportSelection.filters.some(
      (f) => f.filter === 'FirmType',
    )
  }
  // Do not need parameters.
  public pdfReportValueChange() {
    this.showPdfActiveCheckbox = this.pdfReportSelection.filters.some(
      (f) => f.filter === 'Active',
    )
    this.showPdfRepDropdown = this.pdfReportSelection.filters.some(
      (f) => f.filter === 'Rep',
    )
    this.showPdfRepMultiselect = this.pdfReportSelection.filters.some(
      (f) => f.filter === 'RepList',
    )
  }

  public multiSelectValueChange() {
    this.pdfRepSelectionList.length
    this.sortedRepList = this.activeRepList
    this.sortedRepList = this.sortedRepList.filter(
      (rep) => this.pdfRepSelectionList.indexOf(rep) === -1,
    )
    this.sortedRepList = this.pdfRepSelectionList.concat(this.sortedRepList)
  }

  public pdfRepSelectListSelectAll() {
    this.sortedRepList = this.activeRepList
    this.pdfRepSelectionList = this.sortedRepList
  }
  showToast(status: 'success' | 'error' | 'info' | 'warning', message: string) {
    switch (status) {
      case 'success':
        this.toastrService.success(message, 'Success');
        break;
      case 'error':
        this.toastrService.error(message, 'Error');
        break;
      case 'info':
        this.toastrService.info(message, 'Info');
        break;
      case 'warning':
        this.toastrService.warning(message, 'Warning');
        break;
      default:
        this.toastrService.show(message);
        break;
    }
  }
}
